<template>
    <section class="list"
             v-if="!schedule.loading && !schedule.error">
        <schedule-list-course
            v-for="(item,inx) in LimitScheduleList"
            :key="inx"
            :schedule-course="item"
        />
        <div class="list__no-courses" v-if="!getFilteredScheduleListBySearch.length">
            По Вашему запросу не найдено занятий, измените запрос или выберите другие значения в фильтре.
        </div>
        <div class="list__button-group">
            <div class="btn btn--full btn--white ripple"
                 v-if="ifShow"
                 @click="showMore"
            >
                Показать еще
            </div>
        </div>
    </section>
</template>

<script>
  import {mapGetters, mapState, mapActions} from 'vuex'
  import Schedule from "./Schedule";
  import ScheduleListCourse from "./ScheduleListCourse";

  export default {
    name: "scheduleList",
    components: {ScheduleListCourse, Schedule},
    data() {
      return {
        countView: 12,
      }
    },
    computed: {
      ...mapState([
        'schedule'
      ]),
      ...mapGetters([
        'getFilteredScheduleListBySearch',
        'getFilteredScheduleListBySearchAllDate'
      ]),
      LimitScheduleList() {
        return this.getFilteredScheduleListBySearch.slice(0, this.countView)
      },
      ifShow() {
        return this.getFilteredScheduleListBySearch.length > this.countView
      }
    },
    watch: {
      'getFilteredScheduleListBySearchAllDate': {
        handler: function (val) {
          if (val) {
            this.setAvailableDate([...new Set(val.map(item =>
              item.classes.map(item => item.date)
            ).flat(2))]);
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions([
        'setAvailableDate'
      ]),
      showMore() {
        this.countView = this.countView + 12
      }
    }
  }
</script>

<style lang="scss"
       scoped>
    .list { //schedule
        margin-bottom: 50px;

        &__button-group {
            display: flex;
            margin-right: -10px;
        }

        &__total {
            display: flex;
            color: var(--border);
            margin-bottom: 10px;
            font-size: 11px;
        }
        
        &__no-courses {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 18px 30px;
            background-color: rgb(218, 220, 226);
            border-radius: 5px;
            font-weight: 500;
        }
    }
</style>
